<div class="modal" [ngStyle]="{'display':showApprovalPopUp?'block':'none'}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{sessionTakeoverApprovalLabel}}</h5>
      </div>
      <div class="modal-body text-center">
        <p>{{messageLabel}}{{timerCount}}seconds</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn button-primary"
          (click)="updateSessionOverTakeResponse(true)">{{allowLabel}}</button>
        <button type="button" class="btn button-danger" data-dismiss="modal"
          (click)="updateSessionOverTakeResponse(false)">{{denyLabel}}</button>
      </div>
    </div>
  </div>
</div>